/* eslint import/prefer-default-export: 0 */

// dependencies
import moment from "moment";
import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";
import { parse, addMinutes, toDate } from "date-fns";

// utils
import parseUserAgent from "Utils/userAgentParser";
import objectToQueryString from "Utils/objectToQueryString";

// selectors
import { getCurrentEnvironmentName } from "Selectors/app";

export const GetRequests = CreateProcess({
	method: "GET",
	name: "GetRequests",
	type: "REQUESTS:GET",

	request: (props, { getState }) => {
		const state = getState();
		const environment = getCurrentEnvironmentName(state);

		const queryString = props.params ? objectToQueryString(props.params) : objectToQueryString(props);

		return {
			url: `/${environment}/requests/?${queryString}`,
		};
	},

	success: (response) => {
		let requests = fromJS(response.data.items);

		requests = requests.withMutations((mutable) => {
			requests.forEach((item, ii) => {
				const endTime = item.get("end_time") * 1000;
				const startTime = item.get("start_time") * 1000;
				const deltaTime = endTime - startTime;
				const parsedUserAgent = parseUserAgent(item.get("user_agent"));

				mutable.setIn([ii, "id"], item.get("_id"));
				mutable.setIn([ii, "companyID"], item.get("company_id"));
				mutable.setIn([ii, "userID"], item.get("user_id"));
				mutable.setIn([ii, "userAgent"], item.get("user_agent"));
				mutable.setIn([ii, "gitBranch"], item.get("git_branch"));
				mutable.setIn([ii, "gitHash"], item.get("git_hash"));
				mutable.setIn([ii, "startTime"], moment(endTime));
				mutable.setIn([ii, "endTime"], moment(startTime));
				mutable.setIn([ii, "deltaTime"], deltaTime);
				mutable.setIn([ii, "userAgentParsed"], fromJS(parsedUserAgent));

				mutable.deleteIn([ii, "_id"]);
				mutable.deleteIn([ii, "company_id"]);
				mutable.deleteIn([ii, "user_id"]);
				mutable.deleteIn([ii, "user_agent"]);
				mutable.deleteIn([ii, "git_branch"]);
				mutable.deleteIn([ii, "git_hash"]);
				mutable.deleteIn([ii, "start_time"]);
				mutable.deleteIn([ii, "end_time"]);
			});
		});

		return fromJS({
			requests,
			requestsCount: response.data.count,
		});
	},
});

export const GetRequestsPerMinute = CreateProcess({
	method: "GET",
	name: "GetRequestsPerMinute",
	type: "REQUESTS:RPM",

	request: (props, { getState }) => {
		const state = getState();
		const environment = getCurrentEnvironmentName(state);

		return {
			url: `/${environment}/requests-per-time-bucket/`,
		};
	},

	success: (response) => {
		const { requestsPerMinute, startTime } = response.data;

		// generate item for each minute of the last 24 hours
		const buckets = [];
		const bucketSize = 5;
		const start = toDate(startTime);
		const startSeconds = start / 1000;
		const bucketCount = (24 * 60) / bucketSize;

		for (let ii = 0; ii < bucketCount; ii += 1) {
			buckets.push({ date: addMinutes(start, ii * bucketSize), value: 0 });
		}

		// fill in the buckets with data
		requestsPerMinute.forEach((item) => {
			const index = (item.timestamp - startSeconds) / (60 * 5);

			buckets[index].value = item.count;
			buckets[index].max = item.max * 1000;
			buckets[index].mean = item.average * 1000;
			buckets[index].uniqueUsersCount = item.uniqueUsersCount;
		});

		return fromJS(buckets);
	},
});
